import { DatePicker, DateHelper } from '@3plearning/react-components';
import { SELECTED_DATE } from '../../filter-constants';
import dropdownDataSelectors from '../../redux/dropdown-data/dropdown-data-selectors';
import { trackEvent, ANALYTICS_EVENTS } from '../../../../helpers/analytics';

export const SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS';
export const UPDATE_ACTIVE_FILTER = 'UPDATE_ACTIVE_FILTER';

/**
 * Set all active filters
 * Values not provided will retain their current value
 */
function setActiveFilters(filters) {
    return (dispatch, getState) => {
        const selectedDate = filters[SELECTED_DATE];
        if (selectedDate) {
            filters[SELECTED_DATE] = validateDate(
                selectedDate,
                getState().academicYear
            );
        }
        dispatch({
            type: SET_ACTIVE_FILTERS,
            payload: filters
        });
    };
}

/**
 * Update one active filter to the specified value
 */
function updateActiveFilter(filterName, filterValue) {
    return (dispatch, getState) => {
        if (filterName === SELECTED_DATE) {
            filterValue = validateDate(filterValue, getState().academicYear);
        }
        trackEvent(ANALYTICS_EVENTS.filterChanged, { filter: filterName });
        dispatch({
            type: UPDATE_ACTIVE_FILTER,
            payload: {
                filterName,
                filterValue
            }
        });
    };
}

function setFiltersFromSelectedOptions() {
    return (dispatch, getState) => {
        const selectedOptions = dropdownDataSelectors.selectAllSelectedOptions(
            getState()
        );
        dispatch(setActiveFilters(selectedOptions));
    };
}

/**
 * Enforces correct start/end dates for non-custom date ranges
 */
function validateDate(selectedDate, academicYear) {
    let { startDate, endDate } = selectedDate;
    switch (selectedDate.type) {
        case DatePicker.THIS_WEEK:
            ({ startDate, endDate } = DateHelper.getThisWeekStartEnd());
            break;
        case DatePicker.LAST_WEEK:
            ({ startDate, endDate } = DateHelper.getLastWeekStartEnd());
            break;
        case DatePicker.THIS_SCHOOL_YEAR:
        case DatePicker.LIFETIME:
            ({ startDate, endDate } = academicYear);
            break;
        default:
    }

    return {
        type: selectedDate.type,
        startDate,
        endDate
    };
}

export default {
    setActiveFilters,
    updateActiveFilter,
    setFiltersFromSelectedOptions
};



// WEBPACK FOOTER //
// ./components/report-filters/redux/active-filters/active-filters-actions.js